export var ServerResponseError = /*#__PURE__*/ function(ServerResponseError) {
    ServerResponseError["SERVER_VALIDATION_UNKNOWN_ERROR"] = "SERVER_VALIDATION_UNKNOWN_ERROR";
    return ServerResponseError;
}({});
export const validationErrorMessages = {
    AGREEMENT_ID_MISSING: 'Agreement id missing',
    AGREEMENT_ID_INVALID: 'Agreement id is invalid',
    AGREEMENT_NOT_BILLABLE: 'Agreement is not billable',
    AGREEMENT_DOESNT_EXIST: 'Agreement id not found',
    AGREEMENT_SAMPLE_NOT_BILLABLE: 'Sample agreements cannot be billed',
    ISSUE_DATE_MISSING: 'Issue date value is missing',
    ISSUE_DATE_INVALID: 'Invalid issue date format - use MM-DD-YYYY',
    ISSUE_DATE_PAST_LIMIT_EXCEEDED: 'Issue date can be up to one year in the past when using "BILL_NOW"',
    ISSUE_DATE_CANT_BE_IN_THE_PAST_WHEN_USING_BILL_ON_DATE: 'Issue date cannot be set in the past when using "BILL_ON_DATE"',
    ISSUE_DATE_FUTURE_LIMIT_EXCEEDED: 'Issue date cannot be more than one year in the future when using "BILL_ON_DATE"',
    ISSUE_DATE_CANT_BE_IN_THE_FUTURE_WHEN_USING_BILL_NOW: 'Issue date cannot be set in the future when using "BILL_NOW"',
    BILL_TYPE_MISSING: 'Bill type is missing',
    BILL_TYPE_INVALID: "Invalid 'Bill Type' format - use BILL_NOW or BILL_ON_DATE",
    TYPE_MISSING: 'Type value is missing',
    TYPE_INVALID: 'Invalid type format - use IN_AGREEMENT or OUT_OF_SCOPE',
    SERVICE_NAME_MISSING: 'Service name is missing',
    SERVICE_DOESNT_EXIST: 'Service not found',
    SERVICE_NOT_INCLUDED_IN_AGREEMENT: 'Service not found',
    SERVICE_NAME_EXIST_MORE_THAN_ONCE_ON_AGREEMENT: 'This service name exists more than once in the agreement',
    SERVICE_IS_NOT_BILLABLE: 'Service is no longer billable',
    RATE_IS_REQUIRED_FOR_SERVICE: 'Rate value is missing',
    QUANTITY_IS_REQUIRED_FOR_SERVICE: 'Quantity value is missing',
    QUANTITY_SUPPOSE_TO_BE_EMPTY_FOR_RANGE_SERVICE: 'Quantity should be left empty for services with "Range" pricing',
    RATE_SUPPOSE_TO_BE_EMPTY_FOR_UNIT_SERVICE: 'Rate should be left empty for services with "Price per unit" pricing',
    QUANTITY_INVALID: 'Quantity value is invalid. Use a decimal number with no more than two decimal places.',
    RATE_INVALID: 'Rate value is invalid. Use a positive decimal number with no more than two decimal places.',
    RATE_CANT_BE_NEGATIVE: 'Rate value is invalid',
    UNIT_DISCOUNT_INVALID: 'Unit discount value is invalid',
    UNIT_DISCOUNT_SHOULD_BE_EMPTY_WHEN_IN_AGREEMENT: 'Unit discount should be left empty for IN_AGREEMENT services',
    UNIT_DISCOUNT_EXCEEDS_RATE: 'Unit discount cannot exceed the rate',
    FILE_IS_EMPTY: 'File is empty',
    UNKNOWN: 'An unknown error occurred. please contact support for assistance',
    TYPE_HEADER_IS_MISSING: 'Missing column: "type"',
    ISSUE_DATE_HEADER_IS_MISSING: 'Missing column: "issue_date"',
    BILL_TYPE_HEADER_IS_MISSING: 'Missing column: "bill_type"',
    AGREEMENT_ID_HEADER_IS_MISSING: 'Missing column: "agreement_id"',
    SERVICE_NAME_HEADER_IS_MISSING: 'Missing column: "service_name"',
    QUANTITY_HEADER_IS_MISSING: 'Missing column: "quantity"',
    RATE_HEADER_IS_MISSING: 'Missing column: "rate"',
    UNIT_DISCOUNT_HEADER_IS_MISSING: 'Missing column: "unit_discount"',
    NOTE_HEADER_IS_MISSING: 'Missing column: "note"',
    CSV_MUST_CONTAIN_AT_LEAST_ONE_CHARGE: 'File must contain at least one charge',
    QUANTITY_SUPPOSE_TO_BE_EMPTY_FOR_FIXED_SERVICE: 'Quantity should be left empty for services with fixed pricing',
    RATE_SUPPOSE_TO_BE_EMPTY_FOR_FIXED_SERVICE: 'Rate should be left empty for services with fixed pricing',
    CLIENT_NAME_HEADER_IS_MISSING: 'Missing column: "client_name"',
    CLIENT_NAME_AND_AGREEMENT_ID_MISSING: 'Client name and agreement ID are missing',
    CLIENT_NAME_DOESNT_EXIST: 'Client not found',
    CLIENT_NAME_INVALID: 'Client name is invalid',
    CLIENT_NAME_AGREEMENT_ID_MISMATCH: "This client doesn't have an agreement with this ID",
    CLIENT_NAME_EXIST_MORE_THAN_ONCE: 'This company name appears more than once. Please specify the exact agreement ID',
    MORE_THAN_ONE_AGREEMENT_FOR_THE_COMPANY: 'Multiple agreements found for this client. Please provide the agreement ID',
    NO_BILLABLE_AGREEMENT_FOR_THE_COMPANY: 'No billable agreements found for this client',
    CSV_FILE_ROW_LIMIT_EXCEEDED: 'The file exceeds the maximum limit of 1000 lines. Please reduce the number of lines and try again.',
    SERVICE_CANT_BE_BILLED_MORE_THAN_DEFINED_LIMIT: 'This service cannot be billed more than the defined limit.',
    AGREEMENT_NOT_BILLABLE_BEFORE_EFFECTIVE_DATE: 'Invoices can’t be issued before the agreement’s effective date.',
    BUNDLE_SERVICE_TEMPLATE_NOT_ALLOWED: 'Bundles can’t be billed as an out-of-scope charge.',
    SERVICE_NOT_BILLABLE_BEFORE_EFFECTIVE_DATE: 'Invoices can’t be issued for this service before its start date.',
    // server response errors -
    ["SERVER_VALIDATION_UNKNOWN_ERROR"]: 'Failed to validate file for unknown reason. Please try again.'
};
const getKeyMessage = (code)=>{
    var _validationErrorMessages_code;
    return (_validationErrorMessages_code = validationErrorMessages[code]) !== null && _validationErrorMessages_code !== void 0 ? _validationErrorMessages_code : 'error code: "'.concat(code, '"');
};
export const getRowErrorMessage = (error)=>{
    return "Row ".concat(error.row, ": ").concat(getKeyMessage(error.code));
};
export const getGlobalErrorMessage = (error)=>{
    return getKeyMessage(error.code);
};
